<template>
  <div class="main-container">
    <!-- 设备列表 -->
    <el-dialog
      title="设备管理"
      width="80vw"
      :visible.sync="deviceVisible"
      :close-on-click-modal="false"
      class="deviceEditDialog"
    >
      <el-dialog
        title="设备编辑"
        :close-on-click-modal="false"
        :visible.sync="deviceEditVisible"
        append-to-body
      >
        <el-form
          :model="deviceEditForm"
          label-width="100px"
          ref="deviceEditForm"
          :rules="deviceEditRules"

        >
          <el-row>
            <el-form-item
              label="SN码"
              prop="DeviceNo"
            >
              <el-input
                v-model="deviceEditForm.DeviceNo"
                autocomplete="off"
                placeholder="请输入SN码"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="设备名称"
                prop="DeviceName"
              >
                <el-input
                  v-model="deviceEditForm.DeviceName"
                  autocomplete="off"
                  placeholder="请输入设备名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品型号">
                <el-select
                  v-model="deviceEditForm.ProductID"
                  placeholder="请选择产品型号"
                  style="width:100%"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in productOptions"
                    :key="item.ProductID"
                    :label="item.Name"
                    :value="item.ProductID"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="所在项目">
                <el-select
                  v-model="deviceEditForm.PrjID"
                  placeholder="请选择项目"
                  style="width:100%"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in prjOptions"
                    :key="item.PrjID"
                    :label="`${item.PrjName}（${item.PrjCode}）`"
                    :value="item.PrjID"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="IP地址">
                <el-input
                  v-model="deviceEditForm.IPAddress"
                  autocomplete="off"
                  placeholder="请输入IP地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="通讯方式"
                prop="CommunicateMode"
              >

                <el-select
                  v-model="deviceEditForm.CommunicateMode"
                  placeholder="请选择通讯方式"
                  style="width:100%"
                  clearable
                >
                  <el-option
                    v-for="item in communicateOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="模式"
                prop="Mode"
              >
                <el-select
                  v-model="deviceEditForm.Mode"
                  placeholder="请选择模式"
                  style="width:100%"
                  clearable
                >
                  <el-option
                    v-for="item in modeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="备注">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入备注"
                v-model="deviceEditForm.Remark"
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-row>
        </el-form>

        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="deviceEditVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="submitForm('deviceEditForm')"
            :loading="sumbitLoading"
          >确 定</el-button>
        </div>
      </el-dialog>
      <el-form
        :inline="true"
        :model="c_searchForm"
        class="c_searchForm"
         size="mini"
      >
        <el-form-item
          label="状态"
          style="margin-bottom:0"
        >
          <el-select
            v-model="c_searchForm.IsConnected"
            placeholder="请选择状态"
            style="width:120px"
            clearable
            @change="changeStatus"
          >
            <el-option
              v-for="item in connectedOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="SN码"
          style="margin-bottom:0"
        >
          <el-input
            v-model="c_searchForm.DeviceNo"
            placeholder="请输入SN码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="IMEI"
          style="margin-bottom:0"
        >
          <el-input
            v-model="c_searchForm.IMEI"
            placeholder="请输入IMEI"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="ICCID"
          style="margin-bottom:0"
        >
          <el-input
            v-model="c_searchForm.ICCID"
            placeholder="请输入ICCID"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="设备名称"
          style="margin-bottom:0"
        >
          <el-input
            v-model="c_searchForm.DeviceName"
            placeholder="请输入设备名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom:0">
          <el-button
            type="primary"
            @click="c_search"
          >查询</el-button>
        </el-form-item>

      </el-form>
      <el-table
        :data="deviceTable.data"
        border
        height="100%"
        stripe

        style="width: 100%"
        :header-cell-style="{background:'#2c86d1',color:'white',textAlign:'center'}"
        :cell-style="{textAlign:'center'}"
      >
        <el-table-column
          prop="IsConnected"
          label="状态"
          align="center"
          width="50"
        >
          <template slot-scope="scope">
            <i
              v-if="scope.row.IsConnected"
              class="el-icon-success"
              style="color:#67c23a;font-size:24px"
            ></i>
            <i
              v-else
              class="el-icon-error"
              style="color:#f56c6c;font-size:24px"
            ></i>
          </template>
        </el-table-column>
        <el-table-column
          prop="PrjName"
          label="项目名称"
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="ProductName"
          label="产品型号"
        >
        </el-table-column>
        <el-table-column
          prop="DeviceNo"
          label="SN码"
          width="140"
        >
        </el-table-column>
        <el-table-column
          prop="DeviceName"
          label="设备名称"
        >
        </el-table-column>
        <el-table-column
          prop="CommunicateMode"
          label="通讯方式"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.CommunicateMode===1">以太网</div>
            <div
              v-if="scope.row.CommunicateMode===2"
              type="danger"
            >4G</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="Mode"
          label="状态模式"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.Mode===0">调试模式</div>
            <div
              v-if="scope.row.Mode===1"
              type="danger"
            >工程模式</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="UpdateTime"
          label="创建时间"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="UserName"
          label="创建人"
        >
        </el-table-column>
        <el-table-column
          prop="LastOnLineTime"
          label="最后更新时间"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="IMEI"
          label="IMEI"
          :show-overflow-tooltip="true"
          width="200"
        >
        </el-table-column>
        <el-table-column
          prop="ICCID"
          label="ICCID"
          :show-overflow-tooltip="true"
          width="200"
        >
        </el-table-column>
        <el-table-column
          prop="CSQ"
          label="信号值"
          width="200"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="Ver"
          label="版本"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="240"
        >
          <template slot-scope="scope">
            <el-button
               size="mini"
              v-if="Role != 3"
              @click="editDevice(scope.row)"
            >编辑</el-button>
            <el-popconfirm
              :title="`确认删除设备「${scope.row.DeviceName}」吗`"
              style="margin:0 10px"
              v-if="Role != 3"
              @confirm="delDevice(scope.row.DeviceID)"
            >
              <el-button
                slot="reference"
                size="mini"
                type="danger"
              >删除</el-button>
            </el-popconfirm>
            <el-button
              size="mini"
              type="primary"
              @click="config(scope.row.DeviceID,scope.row.DeviceNo)"
            >远程配置</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="listPage admin_page"
        @size-change="d_handleSizeChange"
        @current-change="d_handleCurrentChange"
        :current-page="deviceTable.pageNum"
        :page-sizes="[15,30,45]"
        :page-size="deviceTable.pageSize"
        layout="total,prev, pager, next, sizes, jumper"
        :total="deviceTable.total"
        background
      >
      </el-pagination>
    </el-dialog>
    <!-- 添加编辑 -->
    <el-dialog
      :title="editType==1?'添加':'编辑'"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        ref="editForm"
        :rules="editRules"
      >

        <el-row v-if="editType != 1">
          <el-form-item
            label="项目代码"
            prop="PrjCode"
          >
            <el-input
              v-model="editForm.PrjCode"
              autocomplete="off"
              disabled
              placeholder="请输入项目代码"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="项目名称"
            prop="PrjName"
          >
            <el-input
              v-model="editForm.PrjName"
              autocomplete="off"
              placeholder="请输入项目名称"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="项目地址"
            prop="Address"
          >
            <el-input
              v-model="editForm.Address"
              autocomplete="off"
              placeholder="请输入项目地址"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="项目备注">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入备注"
              v-model="editForm.Remark"
              resize="none"
            >
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="状态"
            prop="Status"
          >
            <el-select
              v-model="editForm.Status"
              placeholder="请选择状态"
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="IP地址">
              <el-input
                v-model="editForm.IPAddress"
                autocomplete="off"
                placeholder="请输入IP地址"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="端口">
              <el-input
                v-model="editForm.Port"
                autocomplete="off"
                placeholder="请输入端口"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="经度">
              <el-input
                v-model="editForm.lon"
                autocomplete="off"
                placeholder="请输入经度"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度">
              <el-input
                v-model="editForm.Lat"
                autocomplete="off"
                placeholder="请输入纬度"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('editForm')"
          :loading="sumbitLoading"
        >确 定</el-button>
      </div>
    </el-dialog>
    <div class="toolBox">
      <div class="leftBox">
        <el-form
          :inline="true"
          :model="searchForm"
          class="searchForm"
          size="mini"
        >
          <el-form-item
            label="项目名称"
            style="margin-bottom:0"
          >
            <el-input
              v-model="searchForm.PrjName"
              placeholder="请输入项目名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="状态"
            style="margin-bottom: 0"
          >
            <el-select
              v-model="searchType"
              placeholder="请选择状态"
              style="width: 120px"
              filterable
              clearable
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="创建时间"
            style="margin-bottom:0"
          >
            <el-date-picker
              v-model="searchDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item style="margin-bottom:0">
            <el-button
              type="primary"
              @click="search"
            >查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="rightBox">
        <el-button
          icon="el-icon-plus"
          @click="add"
          v-if="Role === 1"
          size="mini"
        >添加</el-button>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="table.data"
        border
        height="100%"
        stripe
        style="width: 100%"
        :header-cell-style="{background:'#2c86d1',color:'white',textAlign:'center'}"
        :cell-style="{textAlign:'center'}"
        v-loading="table.loading"
      >
        <el-table-column
          prop="PrjCode"
          label="项目代码"
          minwidth="150"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="PrjName"
          label="项目名称"
          minwidth="150"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="Address"
          label="项目地址"
          minwidth="150"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="Status"
          label="状态"
          width="80"
        >
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.Status===0"
            >调试</el-tag>
            <el-tag
              v-if="scope.row.Status===1"
              type="success"
            >正式使用</el-tag>
            <el-tag
              v-if="scope.row.Status===3"
              type="danger"
            >禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="DeviceCount"
          label="设备数"
          width="80"
        >
        </el-table-column>
        <el-table-column
          prop="DeviceOnlineCount"
          label="在线"
          width="80"
        >
        </el-table-column>
        <el-table-column
          prop="DeviceOfflineCount"
          label="离线"
          width="80"
        >
        </el-table-column>
        <el-table-column
          prop="CreateTime"
          label="创建时间"
          minwidth="150"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="UserName"
          label="创建人"
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="Remark"
          label="备注"
          minwidth="150"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="350"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="edit(scope.row)"
              v-if="Role === 1"
            >编辑</el-button>
            <el-popconfirm
              :title="`确认删除项目「${scope.row.PrjName}」吗`"
              style="margin:0 10px"
              @confirm="del(scope.row.PrjID)"
            >
              <el-button
                slot="reference"
                size="mini"
                type="danger"
                v-if="Role === 1"
              >删除</el-button>
            </el-popconfirm>
            <el-button
              size="mini"
              type="primary"
              @click="searchDevice(scope.row.PrjID)"
            >设备管理</el-button>
            <el-button
              size="mini"
              type="primary"
              @click="UserDevice(scope.row.PrjID)"
            >用户管理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="listPage admin_page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="table.pageNum"
        :page-sizes="[15,30,45]"
        :page-size="table.pageSize"
        layout="total,prev, pager, next, sizes, jumper"
        :total="table.total"
        background
      >
      </el-pagination>
    </div>
    <!-- 用户管理列表 -->
    <el-dialog
      title="用户管理"
      width="80vw"
      :visible.sync="UserVisible"
      :close-on-click-modal="false"
      class="deviceEditDialog"
    >
      <el-form
          :inline="true"
          :model="userForm"
          class="searchForm"
           size="mini"
        >
        <el-form-item
          label="账号"
          style="margin-bottom:0"
        >
          <el-input
            v-model="userForm.UserCode"
            placeholder="请输入账号"
            clearable
          ></el-input>
        </el-form-item>
          <el-form-item style="margin-bottom:0">
          <el-button
            type="primary"
            @click="user_search"
          >查询</el-button>
        </el-form-item>

      </el-form>
      <el-table
        :data="UserTable.data"
        border
        height="100%"
        stripe

        style="width: 100%"
        :header-cell-style="{background:'#2c86d1',color:'white',textAlign:'center'}"
        :cell-style="{textAlign:'center'}"
      >
        <el-table-column
            prop="PrjCode"
            label="项目代码"
            minwidth="150"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="PrjName"
            label="项目名称"
            minwidth="150"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="UserCode"
            label="账号"
            minwidth="150"
          >
          </el-table-column>
          <el-table-column
            prop="UserName"
            label="中文名称"
            minwidth="150"
          >
          </el-table-column>
          <el-table-column
            prop="Telphone"
            label="手机号码"
            minwidth="150"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="200"
          >
            <template  slot-scope="scope">
              <el-popconfirm
                :title="`确认删除项目「${scope.row.PrjName}」吗`"
                style="margin:0 10px"
                @confirm="Userdel(scope.row.PrjID,scope.row.UserID)"
              >
              <el-button
                slot="reference"
                size="mini"
                type="danger"
              >删除</el-button>
            </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      deviceEditVisible: false,
      checkPrjID: null,
      deviceVisible: false,
      UserVisible: false,
      sumbitLoading: false,
      table: {
        data: [],
        loading: false,
        pageSize: 15, //每页显示条数
        pageNum: 1, //当前页数
        total: 0, //总条数
      },
      deviceTable: {
        data: [],
        loading: false,
        pageSize: 15, //每页显示条数
        pageNum: 1, //当前页数
        total: 0, //总条数
      },
      UserTable:{
        data: [],
        loading: false,
        pageSize: 15, //每页显示条数
        pageNum: 1, //当前页数
        total: 0, //总条数
      },
      connectedOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: true,
          label: "在线",
        },
        {
          value: false,
          label: "离线",
        },
      ],
      searchForm: {
        PrjName: null,
        Status: null,
      },
      userForm:{
        UserCode:null,
      },
      searchType: null,
      searchDate: [],
      c_searchForm: {
        DeviceNo: null,
        ICCID: null,
        DeviceName: null,
        IMEI: null,
        IsConnected: true,
      },
      statusOptions: [
        {
          value: 0,
          label: "调试",
        },
        {
          value: 1,
          label: "正式使用",
        },
        {
          value: 3,
          label: "禁用",
        },
      ],
      deviceEditRules: {
        DeviceNo: [
          {
            required: true,
            message: "请输入SN码",
            trigger: "blur",
          },
        ],
        DeviceName: [
          {
            required: true,
            message: "请输入SN码",
            trigger: "blur",
          },
        ],
        CommunicateMode: [
          {
            required: true,
            message: "请选择通讯方式",
            trigger: "change",
          },
        ],
        Mode: [
          {
            required: true,
            message: "请选择模式",
            trigger: "change",
          },
        ],
      },

      deviceEditForm: {},
      productOptions: [],
      prjOptions: [],
      modeOptions: [
        {
          value: 0,
          label: "调试模式",
        },
        {
          value: 1,
          label: "工程模式",
        },
      ],
      communicateOptions: [
        {
          value: 1,
          label: "以太网",
        },
        {
          value: 2,
          label: "4G",
        },
      ],
      editType: 1, //1添加2编辑
      editFormVisible: false,
      editForm: {},
      editRules: {
        PrjCode: [
          {
            required: true,
            message: "请输入项目代码",
            trigger: "blur",
          },
        ],
        PrjName: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
        ],
        Address: [
          {
            required: true,
            message: "请输入项目地址",
            trigger: "blur",
          },
        ],
        Status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
      },
    };
  },
  components: {},
  computed: {
    ...mapGetters(["SessionId", "UserId", "Role"]),
    ...mapState("settings", ["jumpCheckPrjID", "isJump"]),
  },
  mounted() {
    this.getList();
    if (this.jumpCheckPrjID && this.isJump) {
      this.searchDevice(this.jumpCheckPrjID);
      // this.UserDevice(this.jumpCheckPrjID);
      this.$store.commit("settings/SET_PRJID", "");
      this.$store.commit("settings/SET_JUMP_STATUS", false);
    }
  },
  methods: {
    changeStatus(val) {
      this.deviceTable.pageNum = 1;
      this.deviceTable.pageSize = 15;
      this.getDeviceList(this.checkPrjID, this.c_searchForm);

    },
    config(DeviceID, DeviceNo) {
      this.$store.commit("user/SET_USERINFO_DETAIL", {
        key: "DeviceID",
        value: DeviceID,
      });
      this.$store.commit("user/SET_USERINFO_DETAIL", {
        key: "GatewayCode",
        value: DeviceNo,
      });
      this.$store.commit("settings/SET_PRJID", this.checkPrjID);
      this.$router.push({
        path: "/admin/device",
        query: { DeviceID: DeviceID, DeviceNo: DeviceNo },
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == "editForm") {
            this.sumbit();
          } else if (formName == "deviceEditForm") {
            this.sumbitDevice();
          }
        } else {
          return false;
        }
      });
    },
    //翻页事件
    handleSizeChange(val) {
      this.table.pageSize = val;
      if (!this.searchDate) {
        this.searchDate = [];
      }
      this.getList(this.searchForm, this.searchType, ...this.searchDate);
    },
    //翻页事件
    handleCurrentChange(val) {
      this.table.pageNum = val;
      if (!this.searchDate) {
        this.searchDate = [];
      }
      this.getList(this.searchForm, this.searchType, ...this.searchDate);
    },
    //翻页事件
    d_handleSizeChange(val) {
      this.deviceTable.pageSize = val;
      this.getDeviceList(this.checkPrjID, this.c_searchForm);
    },
    //翻页事件
    d_handleCurrentChange(val) {
      this.deviceTable.pageNum = val;
      this.getDeviceList(this.checkPrjID, this.c_searchForm);
    },
    editDevice(data) {
      this.deviceEditForm = {
        DeviceNo: null,
        DeviceName: null,
        ProductID: null,
        PrjID: null,
        IPAddress: null,
        CommunicateMode: null,
        Mode: null,
        Remark: null,
      };
      if (this.$refs["deviceEditForm"]) {
        this.$refs["deviceEditForm"].resetFields();
      }
      this.deviceEditForm = JSON.parse(JSON.stringify(data));
      this.getPrjList()
        .then(() => {
          return this.getProductList();
        })
        .then(() => {
          console.log(123);
          this.deviceEditVisible = true;
        });
    },
    async delDevice(DeviceID) {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          DeviceID,
        },
      };
      //添加

      const res = await this.$api.axios_http(
        this.$gd.admin.device.delete,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.getDeviceList(this.checkPrjID);
      } else {
        this.$message.error(res.Error);
      }
    },
    async sumbitDevice() {
      this.sumbitLoading = true;
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: { ...this.deviceEditForm },
      };
      let res = await this.$api.axios_http(
        this.$gd.admin.device.edit,
        obj,
        "POST"
      );
      this.sumbitLoading = false;
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.deviceEditVisible = false;
        this.getDeviceList(this.checkPrjID);
      } else {
        this.$message.error(res.Error);
      }
    },
    getPrjList() {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {},
      };
      return new Promise((resolve) => {
        this.$api
          .axios_http(this.$gd.admin.project.getList, obj, "POST")
          .then((res) => {
            if (res.ReturnCode == 0) {
              this.prjOptions = res.ReturnList;
              resolve();
            } else {
              this.$message.error(res.Error);
            }
          });
      });
    },
    getProductList() {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {},
      };
      return new Promise((resolve) => {
        this.$api
          .axios_http(this.$gd.admin.product.getList, obj, "POST")
          .then((res) => {
            if (res.ReturnCode == 0) {
              this.productOptions = res.ReturnList;
              resolve();
            } else {
              this.$message.error(res.Error);
            }
          });
      });
    },
    add() {
      this.reset();
      this.editType = 1;
      this.editFormVisible = true;
    },
    edit(data) {
      this.reset();
      this.editForm = JSON.parse(JSON.stringify(data));
      this.editType = 2;
      this.editFormVisible = true;
    },
    searchDevice(PrjID) {
      this.getDeviceList(PrjID, this.c_searchForm).then(() => {
        this.checkPrjID = PrjID;
        this.deviceVisible = true;
      });
    },
    UserDevice(PrjID){
      console.log('我点击了',PrjID)
       this.UserDeviceList(PrjID,this.userForm).then(()=>{
         this.checkPrjID = PrjID;
         this.UserVisible = true;
      })
    },
    // 表单重置
    reset() {
      this.editForm = {
        PrjCode: null,
        PrjName: null,
        Address: null,
        Remark: null,
        Status: 0,
        IPAddress: null,
        Port: null,
        lon: null,
        Lat: null,
      };
      if (this.$refs["editForm"]) {
        this.$refs["editForm"].resetFields();
      }
    },
    search() {
      this.table.pageNum = 1;
      this.table.pageSize = 15;
      if (!this.searchDate) {
        this.searchDate = [];
      }
      this.getList(this.searchForm, this.searchType, ...this.searchDate);
    },
    c_search() {
      this.deviceTable.pageNum = 1;
      this.deviceTable.pageSize = 15;
      this.getDeviceList(this.checkPrjID, this.c_searchForm);
    },
    user_search(){
      this.UserTable.pageNum = 1;
      this.UserTable.pageSize = 15;
      this.UserDeviceList(this.checkPrjID, this.userForm);
    },
    getDeviceList(PrjID, searchForm) {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          PageNumber: this.deviceTable.pageNum,
          PageSize: this.deviceTable.pageSize,
          SearchList: [
            {
              CompareType: "Equal",
              PropertyName: "PrjID",
              PropertyValue: PrjID,
            },
          ],
          SortList: [
            {
              SortDescend: true,
              SortProperty: "UpdateTime",
            },
          ],
        },
      };
      if (searchForm) {
        Object.keys(searchForm).forEach(function (key) {
          if (searchForm[key] || searchForm[key] === false) {
            if (key == "IsConnected") {
              obj.Params.SearchList.push({
                CompareType: "Equal",
                PropertyName: key,
                PropertyValue: searchForm[key],
              });
            } else {
              obj.Params.SearchList.push({
                CompareType: "Contains",
                PropertyName: key,
                PropertyValue: searchForm[key],
              });
            }
          }
        });
      }
      return new Promise((resolve) => {
        this.$api
          .axios_http(this.$gd.admin.device.getList, obj, "POST")
          .then((res) => {
            if (res.ReturnCode == 0) {
              if (res.ReturnList && res.ReturnList.length > 0) {
                res.ReturnList.forEach((item) => {
                  if (item.UpdateTime) {
                    item.UpdateTime = this.$moment(item.UpdateTime).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                  }
                  if (item.LastOnLineTime) {
                    item.LastOnLineTime = this.$moment(
                      item.LastOnLineTime
                    ).format("YYYY-MM-DD HH:mm:ss");
                  }
                });
              }
              this.deviceTable.total = res.RecordCount;
              this.deviceTable.data = res.ReturnList;
              resolve();
            } else {
              this.$message.error(res.Error);
            }
          });
      });
    },
    UserDeviceList(PrjID,userForm){
       let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          PageNumber: this.UserTable.pageNum,
          PageSize: this.UserTable.pageSize,
          SearchList: [
            {
              CompareType: "Equal",
              PropertyName: "PrjID",
              PropertyValue: PrjID,
            },
          ],
          SortList: [
            {
              SortDescend: true,
              SortProperty: "UserCode",
            },
          ],
        },
      };
      if (userForm) {
        Object.keys(userForm).forEach(function (key) {
          if (userForm[key]) {
            obj.Params.SearchList.push({
              CompareType: "Contains",
              PropertyName: key,
              PropertyValue: userForm[key],
            });
          }
        });
      }
      return new Promise((resolve)=>{
        this.$api.axios_http(this.$gd.admin.project.usergetList,obj,"POST").then((res)=>{
          if(res.ReturnCode == 0){
            this.UserTable.total = res.RecordCount;
            this.UserTable.data =res.ReturnList;
            resolve();
            console.log('用户管理列表',this.UserTable.data)
          }else{
            this.$message.error(res.Error);
          }
        })
      })
    },
    // 用户管理删除
    async Userdel(PrjID,UserID){
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          PrjID,
          UserID
        },
      }
      const res = await this.$api.axios_http(this.$gd.admin.project.userDel,obj,"POST");
      if(res.ReturnCode == 0){
        this.$message.success("删除成功");
        this.UserDevice(PrjID)
      }else{
        this.$message.error(res.Error);
      }
    },

    async getList(searchForm, searchType, Stime, Etime) {
      this.table.loading = true;
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          PageNumber: this.table.pageNum,
          PageSize: this.table.pageSize,
          SearchList: [],
          SortList: [
            {
              SortDescend: true,
              SortProperty: "CreateTime",
            },
          ],
        },
      };
      if (Stime) {
        obj.Params.SearchList.push({
          CompareType: "GreaterOrEqual",
          PropertyName: "CreateTime",
          PropertyValue: Stime + " 00:00:00",
        });
      }
      if (Etime) {
        obj.Params.SearchList.push({
          CompareType: "LessOrEqual",
          PropertyName: "CreateTime",
          PropertyValue: Etime + " 23:59:59",
        });
      }
      //项目管理员只能查看自己创建的项目
      // if (this.Role === 2) {
      //     obj.Params.SearchList.push({
      //         CompareType: "Equal",
      //         PropertyName: "CreateUser",
      //         PropertyValue: this.UserId,
      //     });
      // }
      if (searchType || searchType === 0) {
        obj.Params.SearchList.push({
          CompareType: "Equal",
          PropertyName: "Status",
          PropertyValue: searchType,
        });
      }
      if (searchForm) {
        // let search = Object.values(searchForm)
        Object.keys(searchForm).forEach(function (key) {
          // console.log(key, searchForm[key]);
          if (searchForm[key]) {
            obj.Params.SearchList.push({
              CompareType: "Contains",
              PropertyName: key,
              PropertyValue: searchForm[key],
            });
          }
        });
      }
      const res = await this.$api.axios_http(
        this.$gd.admin.project.getList,
        obj,
        "POST"
      );
      this.table.loading = false;
      if (res.ReturnCode == 0) {
        if (res.ReturnList && res.ReturnList.length > 0) {
          res.ReturnList.forEach((item) => {
            if (item.CreateTime) {
              item.CreateTime = this.$moment(item.CreateTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
          });
        }
        this.table.total = res.RecordCount;
        this.table.data = res.ReturnList;
      } else {
        this.$message.error(res.Error);
      }
    },
    async del(PrjID) {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          PrjID,
        },
      };
      //添加

      const res = await this.$api.axios_http(
        this.$gd.admin.project.delete,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.getList(this.searchForm);
      } else {
        this.$message.error(res.Error);
      }
    },
    async sumbit() {
      this.sumbitLoading = true;
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: { ...this.editForm },
      };
      //添加
      let res;
      if (this.editType === 1) {
        res = await this.$api.axios_http(
          this.$gd.admin.project.add,
          obj,
          "POST"
        );
      } else {
        res = await this.$api.axios_http(
          this.$gd.admin.project.edit,
          obj,
          "POST"
        );
      }
      this.sumbitLoading = false;
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.editFormVisible = false;
        if (this.editType === 1) {
          this.table.pageNum = 1;
          this.table.pageSize = 15;
        }
        this.getList(this.searchForm);
      } else {
        this.$message.error(res.Error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .toolBox {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    box-sizing: border-box;
  }
  .c_searchForm {
    margin-bottom: 10px;
  }
  .content {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    padding: 10px;
    padding-top: 0;
  }
}
</style>
<style lang="scss">
.deviceEditDialog {
  .el-dialog__body {
    height: 60vh;
    display: flex;
    flex-direction: column;
  }
}
</style>
